import styled, { keyframes } from 'styled-components';
import Colors from 'library/constants/colors';
import { IconPencil } from 'library/styles/icon';

const load = keyframes`
  0% {
    transform: rotate(0);
    color: ${Colors.shade08};
  }
  50% {
    transform: rotate(180deg);
    color: ${Colors.shade08};
  }
  100% {
    transform: rotate(360deg);
    color: ${Colors.shade08};
  }
`;

export const StyledInput = styled.div`
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  // max-width: ${({ isLongerModal }) => (isLongerModal ? '884px' : '638px')};
  height: 56px;
  box-shadow: 0 1px 0 ${({ hasError }) => (hasError ? Colors.error : Colors.shade06)};
  border-radius: 8px;
  border: none;
  cursor: pointer;
  padding-left: 52px;
  margin-bottom: 10px;
  background-color: ${Colors.shade07};
  background-size: 200% 100%;
  z-index: 1;
  position: relative;
  box-sizing: border-box;

  ::placeholder {
    color: ${({ progress }) => (progress > 10 ? '#fff' : Colors.shade01)};
  };

  &:focus:not(:read-only) {
    box-shadow: 0 2px 0 ${({ hasError }) => (hasError ? Colors.error : Colors.violet)};
    outline: none;
  }

  ${({ readOnly }) => {
    if (readOnly) {
      return `{
        outline: none;
        background-image: linear-gradient(to right, #fff 50%, ${Colors.violet} 50%);
        background-position: ${({ progress }) => (progress > 0 ? `-${progress}% 0;` : 'inherit')};
        transition: ${({ progress }) => (progress ? 'all 0.5s linear' : 'none')};
        color: ${({ progress }) => (progress > 20 ? '#fff' : Colors.shade01)};
        margin-bottom: 1px;
      }`;
    }
    return '';
  }}

  &:hover {
    ${({ readOnly, hasError }) => {
    if (!readOnly) {
      return `box-shadow: 0 2px 0 ${hasError ? Colors.error : Colors.shade04}`;
    }
    return '';
  }}
  }
`;

export const Container = styled.div`
  display: flex;
  //max-width: 638px;
  width: 100%;
  position: relative;
  flex-direction: column;
`;

export const Icon = styled(IconPencil)`
  z-index: 11;
  top: 10px;
  left: 5px;
  animation-name: ${({ isLoading }) => (isLoading ? load : '')};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;

export const Progress = styled.span`
  position: absolute;
  top: 18px;
  right: 24px;
  color: ${({ value }) => (value >= 90 ? Colors.shade08 : 'inherit')};
  font-weight: bold;
  display: block;
  z-index: 2;
`;
